export const environment = {
    production: false,
    //API_URL: "https://qa2.api.claw.buhologistics.com",
    API_URL: "https://qa.api.claw.buhoms.com",
    role_admin_id: 1,
    role_buho_id: 2,
    role_client_id: 3,
    roles: [
      {
        "id": 2,
        "rol": "Buho"
      },{
        "id":3,
        "rol": "Cliente"
      }
    ],
    g_maps_api_key:"AIzaSyA_ypZV6VniexppoU9jHjYLgMC59Ieg_90"
  };